import { Directive, Injector, Optional } from '@angular/core';

import { APPLY_STYLES_TYPE, BaseComponent, IWidgetConfig, Parent, StylableComponent, provideAsWidgetRef, register, styler } from '@wm/components-base';

const WIDGET_CONFIG: IWidgetConfig = {
    widgetType: 'wm-wizardaction',
    hostClass: 'app-wizard-actions panel-footer '
};

@Directive({
    standalone: true,
    selector: 'div[wmWizardAction]',
    providers: [
        provideAsWidgetRef(WizardActionDirective)
    ],
    exportAs: 'wmWizardAction',
})
export class WizardActionDirective extends StylableComponent {
    static initializeProps = register('wm-wizardaction');

    constructor(inj: Injector, @Optional() viewParent: Parent) {
        super(inj, WIDGET_CONFIG, viewParent);
        styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
    }
}
